import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material'
import { Stack } from '@mui/system'
import { FC } from 'react'

interface HistoricalTableProps {
  rows: {
    id: string
    description: string
    jan: string
    feb: string
    mar: string
    apr: string
    may: string
    jun: string
    jul: string
    aug: string
    sep: string
    oct: string
    nov: string
    dec: string
  }[]
}

const HistoricalTable: FC<HistoricalTableProps> = ({ rows }) => {
  return (
    <Stack flexGrow="1">
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          backgroundColor: 'common.white',
          border: '1px solid #EFEFEF',
          borderRadius: '3px',
          '&::-webkit-scrollbar': {
            width: '8px',
            height: '8px',
          },

          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#C1C1C1',
            borderRadius: '5px',
          },
        }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead sx={{ backgroundColor: '#EFEFEF' }}>
            <TableRow>
              <TableCell
                sx={{
                  width: '29px',
                  backgroundColor: '#EFEFEF',
                  position: 'sticky',
                  left: 0,
                }}
              >
                #
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '182px',
                  borderRight: '1px solid #D7D7D7',
                  backgroundColor: '#EFEFEF',
                  position: 'sticky',
                  left: 0,
                }}
              >
                Description
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '93.75px',
                }}
              >
                Jan
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '93.75px',
                }}
              >
                Feb
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '93.75px',
                }}
              >
                Mar
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '93.75px',
                }}
              >
                Apr
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '93.75px',
                }}
              >
                May
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '93.75px',
                }}
              >
                Jun
              </TableCell>

              <TableCell
                sx={{
                  minWidth: '93.75px',
                }}
              >
                Jul
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '93.75px',
                }}
              >
                Aug
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '93.75px',
                }}
              >
                Sep
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '93.75px',
                }}
              >
                Oct
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '93.75px',
                }}
              >
                Nov
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '93.75px',
                }}
              >
                Dec
              </TableCell>

            </TableRow>
          </TableHead>
          <TableBody sx={{ backgroundColor: 'common.white' }}>
            {rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    position: 'sticky',
                    left: 0,
                    backgroundColor: '#FFFFFF',
                  }}
                >
                  {row.id}
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: '1px solid #D7D7D7',
                    position: 'sticky',
                    left: 0,
                    backgroundColor: '#FFFFFF',
                  }}
                >
                  {row.description}
                </TableCell>
                <TableCell>{row.jan}</TableCell>
                <TableCell>{row.feb}</TableCell>
                <TableCell>{row.mar}</TableCell>
                <TableCell>{row.apr}</TableCell>
                <TableCell>{row.may}</TableCell>
                <TableCell>{row.jun}</TableCell>
                <TableCell>{row.jul}</TableCell>
                <TableCell>{row.aug}</TableCell>
                <TableCell>{row.sep}</TableCell>
                <TableCell>{row.oct}</TableCell>
                <TableCell>{row.nov}</TableCell>
                <TableCell>{row.dec}</TableCell>

              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

    </Stack>
  )
}

export default HistoricalTable
